import { checkLogin } from '../utilities/helpers'

const usePermission = () => {
  // const permissions = useSelector(
  //   (state: RootState) => state.accountReducer.permissions
  // )

  const permissions = [] as any[]
  const can = (key: string) => {
    return checkLogin() && permissions?.indexOf(key) !== -1
  }

  return { permissions, can }
}

export default usePermission
